export const paginationFragment = `
  totalItems
  page
  pageSize
  totalPages
`;
